import { render, staticRenderFns } from "./MainStreetCreamery.vue?vue&type=template&id=7acf5b15&scoped=true"
import script from "./MainStreetCreamery.vue?vue&type=script&lang=js"
export * from "./MainStreetCreamery.vue?vue&type=script&lang=js"
import style0 from "./MainStreetCreamery.vue?vue&type=style&index=0&id=7acf5b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acf5b15",
  null
  
)

export default component.exports